import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import Modal from 'antd/lib/modal';
import OpenFileLink from '../components/data-display/OpenFileLink';
import { isSignContractSubmitEnabled } from './signContractModalState';

export class SignContractModalComponent extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    fileLocation: PropTypes.string.isRequired,
    insuranceFileLocation: PropTypes.string,
    title: PropTypes.string.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    checkboxText: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    fileLinktext: PropTypes.string.isRequired,
    showFileLink: PropTypes.bool,
  };

  static defaultProps = {
    showFileLink: true,
  };

  state = {
    signed: false,
  };

  onChecked = e => {
    this.setState({ signed: e.target.checked });
  };

  handleSubmit = e => {
    if (isSignContractSubmitEnabled(this.state.signed)) {
      this.props.onSubmit();
    }
  };

  render() {
    const {
      isLoading,
      hideModal,
      t,
      fileLocation,
      title,
      text,
      checkboxText,
      buttonText,
      insuranceFileLocation,
      fileLinktext,
      showFileLink,
    } = this.props;

    const { signed } = this.state;
    let linkText = fileLinktext || t('Prečítať zmluvu');

    return (
      <Modal
        visible
        confirmLoading={isLoading}
        title={title}
        onOk={this.handleSubmit}
        onCancel={hideModal}
        width={800}
        footer={
          <div>
            <div className="flex-space-between modal-actions">
              {showFileLink && <OpenFileLink href={fileLocation}>{linkText}</OpenFileLink>}
              {
                insuranceFileLocation ?
                <OpenFileLink href={insuranceFileLocation}>{t('Prečítať Žiadosť o zabezpečenie poistenia')}</OpenFileLink>
                : 
                null
              }
            </div>
            <div className='ant-modal-footer'>
              <Button
                size="small"
                type="primary"
                loading={isLoading}
                onClick={this.handleSubmit}
                disabled={!isSignContractSubmitEnabled(signed)}
              >
                {buttonText}
              </Button>
            </div>
          </div>
        }
      >
        <div>
          <p>{text}</p>
          <Checkbox onChange={this.onChecked} checked={signed} className="agreement">
            {checkboxText}
          </Checkbox>
        </div>
      </Modal>
    );
  }
}

export default translate()(SignContractModalComponent);



// WEBPACK FOOTER //
// ./src/common/modals/SignContractModal.js